<template>
  <div
    class="owal-identity-cell__container blue"
    @click="handleClick"
  >
    <div class="owal faces list cell content">
      <div class="owal-faces-list-cell-indicators__container">
        <span
          v-if="!wellTrained"
          class="indicator training-indicator"
        />
        <span
          v-if="role && role === 'tor'"
          class="indicator tor-indicator"
        >
          <font-awesome-icon
            icon="key"
            class="tenant-of-record__icon"
          />
        </span>
      </div>
      <img
        v-if="imageExists"
        :key="identityId"
        v-lazy="urlForIdentityId(identityId)"
        class="owal faces list cell avatar"
      >
      <img
        v-else
        v-lazy="placeholderImageURI"
        :error="placeholderImageURI"
        class="owal faces list cell avatar"
      >
      <span class="owal faces list cell main">
        <span class="owal faces list cell title">{{ titleCasedName(name) }}</span>
        <span
          class="owal faces list cell subtitle left"
        />
      </span>
      <div class="owal faces list cell meta">
        <span class="owal faces list cell subtitle right">{{ detectionRatio(matchRatio) }}%</span>
        <span class="owal faces list cell subtitle right">{{ total || 0 }} taps</span>
      </div>
      <i class="owal faces list cell chevron el-icon-arrow-right" />
    </div>
    <span class="cell-border" />
  </div>
</template>

<script>
import moment from 'moment'
import { titleCase } from '@/libraries/util/string'
import { urlForIdentityId } from '@/libraries/api/faces'

export default {
  name: 'CredentialMismatchListCell',
  props: {
    index: Number,
    name: String,
    matchRatio: Number,
    wellTrained: Boolean,
    role: String,
    total: Number,
    nullMatched: Number,
    lastVerifiedTimestamp: String,
    identityId: String,
    lastSeenUnixTimestamp: Number,
  },
  computed: {
    imageExists (identityId) {
      // TODO: figure out a way to do this that's NOT deprecated
      const http = new XMLHttpRequest()
      const url = this.urlForIdentityId(identityId)
      http.open('HEAD', url, false)
      return http.status !== 404
    },
  },
  methods: {
    urlForIdentityId,
    titleCasedName (name) {
      return titleCase(name)
    },
    handleClick () {
      this.$router.push(`/credential/${this.identityId}`)
      this.$store.commit('credentialMismatch/setCurrentIdentityIndex', this.index)
    },
    detectionRatio (ratio) {
      const percent = ratio * 100
      const output = Math.round(percent * 100) / 100

      return output
    },
    lastVerifiedTimeString (ts) {
      return moment.utc(ts).fromNow()
    },
  },
}
</script>

<style scoped>
  .owal-identity-cell__container {
    display: flex;
    flex-direction: column;
    background-color: rgba(255, 255, 255, 1);
    font-family: 'HelveticaNeue', 'Helvetica', sans-serif;
    cursor: pointer;
  }

  .owal-faces-list-cell-indicators__container {
    position: relative;
    display: inline-flex;
    flex-direction: column;
    justify-content: space-around;
    align-content: center;
    align-items: center;
    margin-left: 0;
    width: 0.75rem;
    height: 100%;
    flex: 0;
    margin-left: 0.25rem;
    align-self: flex-start;
    justify-self: stretch;
  }

  .owal-identity-cell__container.blue:hover,
  .owal.faces.list.active.cell.container.blue {
    background-color: rgba(236, 245, 255, 0.988235);
  }

  /** The indicator spacing. */
  .indicator {
    margin: 0.25rem 0;
  }

  /** Orange dot indicating that an identity needs more training.  */
  .training-indicator {
    background-color: rgb(246, 170, 136);
    display: block;
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 50%;
  }

  /** The tenant of record indicator. */
  .tor-indicator {
    display: block;
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 50%;
  }

  .tenant-of-record__icon {
    display: block;
    width: 0.75rem;
    height: 0.75rem;
  }

  .owal.faces.list.cell.content {
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    padding: 0.33rem 0 0.33 1.06rem;
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .cell-border {
    background: rgba(71, 86, 105, 0.75);
    height: 1px;
    opacity: 0.5;
    width: 100%;
    align-self: flex-end;
    right: 0;
    bottom: 0;
    top: auto;
  }

  .owal.faces.list.avatar {
    background-color: #eff2f7;
    object-fit: cover;
    height: 48px;
    width: 48px;
    border-radius: 24px;
    margin: 0.33rem 1.06rem 0.33rem 1rem;
  }

  .owal.faces.list.cell.title {
    font-size: 1rem;
    flex-shrink: 0;
    flex-grow: 2;
  }

  .owal.faces.list.cell.meta {
    display: flex;
    flex-direction: column;
    margin-right: 0.33rem;
    padding: 0;
    flex-grow: 1;
    flex-shrink: 2;
  }

  .owal.faces.list.cell.subtitle {
    display: flex;
    flex-direction: row-reverse;
    width: 100%;
    font-size: 13px;
    align-self: flex-end;
  }

  .subtitle.right {
    text-align: right;
  }

  .subtitle.left {
    text-align: left;
  }

  .owal.faces.list.cell.chevron {
    width: 24px;
  }

  /** Blue Cell, Title */
  .owal-identity-cell__container .owal.faces.list.cell.title,
  .owal.faces.list.active.cell.container .owal.faces.list.cell.title {
    color: rgb(71, 86, 105);
  }

  /** Blue Cell, Subtitle */
  .owal-identity-cell__container.blue .owal.faces.list.cell.subtitle,
  .owal.faces.list.active.cell.container.blue .owal.faces.list.cell.subtitle {
    color: #8492a6;
  }

  /* Active cell */

  .owal-identity-cell__container,
  .owal-identity-cell__container:hover,
  .owal.faces.list.active.cell.container,
  .owal.faces.list.active.cell.container:hover {
    transition: all 0.3s ease;
  }
  .owal.faces.list.active.cell.container .owal.faces.list.cell.title,
  .owal.faces.list.active.cell.container .owal.faces.list.cell.chevron {
    color: #409eff;
  }
</style>
